import { MuiTelInput, type MuiTelInputProps } from "mui-tel-input";

export const PhoneInput = (props: MuiTelInputProps) => {
  return (
    <MuiTelInput
      defaultCountry="CA"
      preferredCountries={["CA", "US"]}
      placeholder="+1 XXX XXX-XXXX"
      size="small"
      fullWidth
      {...props}
    />
  );
};
